import { FormControl, Grid, Skeleton } from '@mui/material'

export default function FormElement(props = {}) {
    if (!props.show) return <></>
    if (props.loading) {
        return <Grid {...props.gridItemProps} >
            <Skeleton
                variant="rounded"
                height={props.height || props.size === 'small' ? 36 : 54}
            />
        </Grid>
    }
    return <Grid {...props.gridItemProps} >
        <FormControl size={props.size || 'small'} fullWidth>
            {props.children}
        </FormControl>
    </Grid>
}